export default __webpack_public_path__ + "static/media/img_05.ae7e5a52.png";